import moment from 'moment'

import { DateInput } from './DateInput'

export function sortDates(dates:DateInput[]) {
  return (dates || []).map(d => moment(d)).sort((a, b) => a.valueOf() - b.valueOf());
}
